import { FONT_ACTIONS } from '../../actions/fontActions';
import { FONT_STATUS } from "../../constants/common";

const fontReducer = (state = {
  fontStatus: FONT_STATUS.LOADING
}, action) => {
  switch(action.type) {
    case FONT_ACTIONS.FONT_LOAD_STATUS: {
      state = {
        ...state,
        fontStatus: action.payload
      }
      break;
    }
    default : {
      break;
    }
  }
  return state;
}

export default fontReducer;
